import styled from 'styled-components';
import Notice from '@bufferapp/ui/Notice';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 20px;
  width: 100%;
  h3 {
    margin: 8px 0 8px;
  }
  p {
    margin: 0 0 16px;
  }
`;

export const Layout = styled(Notice)`
  position: relative;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0px 1px 5px rgba(61, 61, 61, 0.05),
    0px 8px 12px rgba(61, 61, 61, 0.06);
  border-radius: 4px;
  border: 1px solid #f5f5f5;
  margin-bottom: 16px;
  padding: 0;

  button[type='note'] {
    top: 16px;
    right: 16px;
    svg{
      width: 20px;
      height: 20px;
      }
    }
  }
`;

export const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;
`;

export const FirstButtonContainer = styled.div`
  margin-right: 8px;
  float: left;
`;
